module.exports = __webpack_public_path__ + "img/3-2.f8e999ad.svg";